import { createFileRoute } from "@tanstack/react-router";
import { TransportPage, transportHead } from "@/pages/TransportPage";

export const Route = createFileRoute("/brancher/transport-logistik")({
  head: () => transportHead("da"),
  component: () => <TransportPage locale="da" />,
});
